export const areCoordinatesInsideArea = (point, areaCorners) => {
  const x = point.x,
    y = point.y;

  let inside = false;

  for (let i = 0, j = areaCorners.length - 1; i < areaCorners.length; j = i++) {
    const xi = areaCorners[i][0],
      yi = areaCorners[i][1];
    const xj = areaCorners[j][0],
      yj = areaCorners[j][1];

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }
  return inside;
};

export const getIntersection = (
  x1,
  y1,
  x2,
  y2,
  x3,
  y3,
  x4,
  y4,
  segments = true
) => {
  if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
    return false;
  }

  const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

  if (denominator === 0) {
    return false;
  }

  const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
  const ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

  if ((ua < 0 || ua > 1 || ub < 0 || ub > 1) && segments) {
    return false;
  }

  const x = x1 + ua * (x2 - x1);
  const y = y1 + ua * (y2 - y1);

  return { x, y };
};
